import React from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import VideoForm from "./components/VideoForm";

/**
 * VideoPage - Optimized wrapper component
 * 
 * Key improvements over VideoOld:
 * - Minimal location state dependencies
 * - URL parameter extraction
 * - Clean separation of concerns
 * - Better error handling
 * - Proper node management with getRevAllNodes
 */
const VideoPage = () => {
  const location = useLocation();
  const params = useParams();
  const [searchParams] = useSearchParams();
  
  // Extract URL parameters (primary data source)
  const {
    partnumber,
    revision,
    partId,
    revisionId,
    section_id_ref,
    step_id_ref,
    video_id_ref,
  } = params;
  
  // Extract query parameters for special cases
  const substep_id_ref = searchParams.get("substep_id_ref");
  const node_id_ref = searchParams.get("node_id_ref");
  
  // Determine mode based on URL path
  const mode = location.pathname.includes("/edit-video") ? "edit" : "add";
  
  // Minimal location state usage (only for navigation-specific data)
  const { fromVersionHistory, versionHistoryData } = location.state || {};
  

  return (
    <VideoForm
      // Core props
      mode={mode}
      video_id_ref={video_id_ref}
      
      // URL parameters
      partnumber={partnumber}
      revision={revision}
      partId={partId}
      revisionId={revisionId}
      section_id_ref={section_id_ref}
      step_id_ref={step_id_ref}
      substep_id_ref={substep_id_ref}
      node_id_ref={node_id_ref}

      // Version history props
      fromVersionHistory={fromVersionHistory}
      versionHistoryData={versionHistoryData}
      
    />
  );
};

export default VideoPage;
